import React from 'react';

import {
  ButtonProps,
  CircularProgress,
  Button as MaterialButton,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { useStyles } from './AuthButton.styles';

export interface IAuthButtonBaseProps extends ButtonProps {
  loader?: boolean;
  backgroundColor: string;
  textColor?: string;
  backgroundColorHover?: string;
  borderColor?: string;
  hoverTextColor?: string;
}

export function AuthButtonBase({
  loader = false,
  variant = 'contained',
  className,
  backgroundColor,
  textColor,
  hoverTextColor,
  backgroundColorHover,
  borderColor,
  children,
  ...props
}: IAuthButtonBaseProps) {
  const { classes } = useStyles({
    backgroundColor,
    textColor,
    backgroundColorHover,
    borderColor,
    hoverTextColor,
  });

  return (
    <MaterialButton
      variant={variant}
      className={clsx(classes.button, className)}
      {...props}
      disabled={props.disabled || loader}>
      {loader ? (
        <CircularProgress className={classes.circularProgress} size="24px" />
      ) : (
        children
      )}
    </MaterialButton>
  );
}

type IAuthButtonProps = Omit<
  IAuthButtonBaseProps,
  'backgroundColor' | 'textColor'
>;

export function AuthPrimaryButton(props: IAuthButtonProps) {
  const theme = useTheme();
  const { primary } = theme.palette;

  return (
    <AuthButtonBase
      {...props}
      backgroundColor={primary.main}
      textColor={primary.contrastText}
      borderColor={primary.main}
      backgroundColorHover={primary.dark}
      hoverTextColor={primary.contrastText}
    />
  );
}

export function AuthSecondaryButton(props: IAuthButtonProps) {
  const theme = useTheme();

  return (
    <AuthButtonBase
      {...props}
      backgroundColor={theme.palette.secondary.main}
      backgroundColorHover={theme.palette.primary.main}
      textColor={theme.palette.font.primary}
      hoverTextColor={theme.palette.primary.contrastText}
      borderColor={theme.palette.border.main}
    />
  );
}

export default AuthPrimaryButton;
